import type { Tip } from '@internal/plugin-management-common';
import type { Ticket } from './homeTypes';

export const MAX_HOME_ITEMS = 5;
export const HOME_FAVORITE_LIMIT_DESKTOP = 15;
export const HOME_FAVORITE_LIMIT_MOBILE = 8;

export const getHomeTipCandidates = (tips: Tip[]): Tip[] => {
  const featuredTips = tips.filter(tip => tip.featured);
  return featuredTips.length > 0 ? featuredTips : tips;
};

export const selectHomeTip = (
  tips: Tip[],
  random: () => number = Math.random,
): Tip | undefined => {
  const candidates = getHomeTipCandidates(tips);
  if (candidates.length === 0) return undefined;
  const index = Math.min(
    candidates.length - 1,
    Math.floor(random() * candidates.length),
  );
  return candidates[index];
};

export const buildAssignedTicketsParams = (email: string): URLSearchParams =>
  new URLSearchParams({
    project: '*',
    assignee: email,
    excludeDoneCategory: 'true',
    maxResults: String(MAX_HOME_ITEMS),
  });

export const dateInputValue = (date: Date): string =>
  new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split('T')[0];

export const formatHomeDate = (value?: string | null, chip = false): string => {
  if (!value) return '';
  const date = /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? new Date(`${value}T00:00:00`)
    : new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const formatted = new Intl.DateTimeFormat(chip ? 'en-GB' : 'en', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
  return chip ? formatted.toUpperCase() : formatted;
};

export const isTicketInProgress = (status: string): boolean =>
  ['in progress', 'en progreso'].includes(status.toLowerCase());

export const selectHomeTickets = (tickets: Ticket[]): Ticket[] =>
  [...tickets]
    .sort(
      (a, b) =>
        Number(isTicketInProgress(b.fields.status.name)) -
        Number(isTicketInProgress(a.fields.status.name)),
    )
    .slice(0, MAX_HOME_ITEMS);
